import { AxiosRequestConfig, AxiosResponse } from 'axios';
import client from 'api/client';

export function get(id: string | number, customConfig?: AxiosRequestConfig) {
    const url = `document-resource/${id}`;
    return client.get<{ url: string }>(url, customConfig);
}

export const getDocumentPreviewUrl = (appId: string, docId: number) => {
    return client.get(`/applications/${appId}/documents/${docId}/resource_uri`);
};

export function getBlobDocument(appId: string | number, id: string | number) {
    const url = `applications/${appId}/document-resource/${id}`;
    return client.get<Blob>(url, { responseType: 'blob' }) as Promise<AxiosResponse<Blob>>;
}

export function post(id: string | number, payload: FormData, customConfig?: AxiosRequestConfig) {
    return client.post(`document-resource/${id}`, payload, {
        headers: { 'Content-Type': 'multipart/form-data' },
        ...customConfig,
    });
}
export function del(
    id: string | number,
    customConfig?: AxiosRequestConfig
): Promise<AxiosResponse<{ msg: string }>> {
    return client.delete<{ msg: string }>(`document-resource/${id}`, customConfig);
}
